import {setHours, setMinutes} from 'date-fns'
import moment from 'moment'
import React from 'react'
import DatePicker from 'react-datepicker'
import Iframe from 'react-iframe'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import {getAllUserDetails} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useDispatch, useSelector} from 'react-redux'
import Select from 'react-select'
import {openPopup} from '../../../../../Components/PopupSlice/popupSlice'
import {useTimezone} from '../../../../../hooks/useTimezone'
import {useNewMessage} from '../../useNewMessage'

const Bulk_Message_when_v2 = ({
  isForwardIncomingMessage,
  setIsForwardIncomingMessage,
  bulkMessageData,
  setBulkMessageData,
  checkStep,
  error,
  setError,
  setCheckStep,
}: any) => {
  const userValues = useSelector(getAllUserDetails)
  const {getUserTimezoneNow, timezoneLabel, userTimezone} = useTimezone()
  const userTimezoneNow = getUserTimezoneNow()
  const {isDefaultRegion} = useNewMessage()

  const getSubtitle = (): string => {
    if (!!bulkMessageData?.when) {
      let subtitle

      switch (bulkMessageData?.when) {
        case 'now':
          subtitle = 'Now'
          break
        case 'later':
          subtitle = 'Scheduled'
          break
        default:
          subtitle = 'Choose a schedule or send immediately'
      }

      return subtitle
    } else {
      return 'Choose a schedule or send immediately'
    }
  }

  const SingleWhen = () => {
    return (
      <>
        {bulkMessageData?.abTest ? <h5>Message A</h5> : null}
        <ul className='nav nav-tabs' id='myTab' role='tablist'>
          <li className='nav-item mb-3 me-3' role='presentation'>
            <button
              className='btn btn-outline btn-outline-dashed btn-outline-default nav-link p-4 w-100 px-6'
              id='Now-tab'
              data-bs-toggle='tab'
              data-bs-target='#Now'
              type='button'
              role='tab'
              data-testid='btnSendNowA'
              aria-controls='Now'
              aria-selected='false'
              onClick={() => {
                let errorData = {...error}

                delete errorData.when
                setError(errorData)
                setBulkMessageData({...bulkMessageData, when: 'now', scheduledAt: new Date()})
              }}
            >
              Now
            </button>
          </li>

          <li className='nav-item mb-3 me-3' role='presentation'>
            <button
              className={`nav-link btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 px-6 ${
                !isDefaultRegion && 'd-none'
              }`}
              id='Later-tab'
              data-bs-toggle='tab'
              data-bs-target='#Later'
              type='button'
              role='tab'
              data-testid='btnSendLaterA'
              aria-controls='Later'
              aria-selected='false'
              disabled={!isDefaultRegion}
              onClick={() => {
                setBulkMessageData({...bulkMessageData, when: 'later'})
              }}
            >
              Later
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          {userValues?.smsStatus === 'approved' && !bulkMessageData?.abTest && (
            <div
              className='active fade show tab-pane'
              id='Now'
              role='tabpanel'
              aria-labelledby='Now-tab'
            >
              <div className='when'>
                {isDefaultRegion && (
                  <>
                    <div className='form-check form-check-custom form-check-sm form-check-solid'>
                      <input
                        className='form-check-input me-5'
                        id='option-1'
                        type='radio'
                        checked={
                          !bulkMessageData.isIntervalSend && !bulkMessageData.staggerMessages
                        }
                        onChange={() => {
                          setBulkMessageData({
                            ...bulkMessageData,
                            staggerMessages: false,
                            isIntervalSend: false,
                          })
                        }}
                        name='stagger'
                      />
                      <div>
                        <label htmlFor='option-1' style={{lineHeight: '0.65'}}>
                          Normal Send
                        </label>
                        <p>The message will be sent immediately or at the scheduled time.</p>
                      </div>
                    </div>

                    <div className='form-check form-check-custom form-check-sm form-check-solid'>
                      <input
                        className='form-check-input me-5'
                        id='option-2'
                        type='radio'
                        checked={bulkMessageData.isIntervalSend}
                        onChange={() => {
                          setBulkMessageData({
                            ...bulkMessageData,
                            staggerMessages: false,
                            isIntervalSend: !bulkMessageData.isIntervalSend,
                          })
                        }}
                        name='stagger'
                      />
                      <div>
                        <label htmlFor='option-2' style={{lineHeight: '0.65'}}>
                          Send message over time{' '}
                        </label>
                        <p>Set a period of time for system to send out all your messages</p>
                      </div>
                    </div>
                    {bulkMessageData.isIntervalSend && (
                      <div className='row mb-3 ms-5'>
                        <div className='col-md-5'>
                          <Select
                            name='selector'
                            onChange={(e: any) => {
                              setBulkMessageData({
                                ...bulkMessageData,
                                interval: e.value,
                              })
                            }}
                            placeholder='Select interval'
                            data-testid='ddSelectInterval'
                            className='form-select bg-light-primary border-0 m-3 mb-0'
                            options={[
                              {value: 30, label: '30 Minutes'},
                              {value: 60, label: '1 Hour'},
                              {value: 120, label: '2 Hour'},
                              {value: 180, label: '3 Hour'},
                              {value: 240, label: '4 Hour'},
                              {value: 300, label: '5 Hour'},
                              {value: 360, label: '6 Hour'},
                              {value: 720, label: '12 Hour'},
                              {value: 1440, label: '1 Day'},
                              {value: 2160, label: '2 Day'},
                            ]}
                          />
                        </div>
                      </div>
                    )}

                    <div className='form-check form-check-custom form-check-sm form-check-solid'>
                      <input
                        className='form-check-input me-5'
                        id='option-3'
                        type='radio'
                        checked={bulkMessageData.staggerMessages}
                        onChange={() => {
                          setBulkMessageData({
                            ...bulkMessageData,
                            staggerMessages: !bulkMessageData.staggerMessages,
                            isIntervalSend: false,
                          })
                        }}
                        name='stagger'
                      />
                      <div>
                        <label htmlFor='option-3' style={{lineHeight: '0.65'}}>
                          Stagger messages
                        </label>
                        <p>
                          Set your messages to leave in batches at set intervals - control exposure!
                        </p>
                      </div>
                    </div>
                    {bulkMessageData.staggerMessages && (
                      <div className='row mb-3 ms-5'>
                        <div className='col-md-5'>
                          <Select
                            name='selector'
                            data-testid='ddSelectQuantity'
                            className='form-select bg-light-primary border-0 m-3 mb-0'
                            onChange={(e: any) => {
                              setBulkMessageData({
                                ...bulkMessageData,
                                quantity: e.value,
                              })
                            }}
                            placeholder='Select quantity'
                            options={[
                              {value: 10, label: 10},
                              {value: 20, label: 20},
                              {value: 50, label: 50},
                              {value: 100, label: 100},
                              {value: 150, label: 150},
                              {value: 500, label: 500},
                              {value: 1000, label: 1000},
                              {value: 10000, label: 10000},
                              {value: 25000, label: 25000},
                              {value: 50000, label: 50000},
                              {value: 100000, label: 100000},
                            ]}
                          />
                        </div>
                        <div className='col-md-5'>
                          <Select
                            name='selector'
                            onChange={(e: any) => {
                              setBulkMessageData({
                                ...bulkMessageData,
                                interval: e.value,
                              })
                            }}
                            placeholder='Select interval'
                            data-testid='ddSelectInterval'
                            className='form-select bg-light-primary border-0 m-3 mb-0'
                            options={[
                              {value: 5, label: '5 Minutes'},
                              {value: 10, label: '10 Minutes'},
                              {value: 20, label: '20 Minutes'},
                              {value: 60, label: '1 Hour'},
                              {value: 720, label: '12 Hour'},
                              {value: 1440, label: '24 Hour'},
                            ]}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )}

          <div className='fade tab-pane' id='Later' role='tabpanel' aria-labelledby='Later-tab'>
            <div className='when'>
              {bulkMessageData?.when == 'later' && (
                <div className='col-sm-6 mb-5 select-date'>
                  <label htmlFor='' className='mb-2' data-testid='lblSelectDateA'>
                    Select Date & Time{' '}
                    <span className="">{timezoneLabel}</span>
                  </label>
                  <DatePicker
                    minDate={userTimezoneNow}
                    dateFormat='MMMM d, yyyy h:mm aa'
                    placeholderText='Select a date'
                    showTimeSelect
                    className='col-md-6 form-control form-control-lg form-control-solid border-0'
                    onChange={(e: any) => {
                      // Parse the Date object as if it's in the user's timezone
                      const year = e.getFullYear()
                      const month = e.getMonth()
                      const day = e.getDate()
                      const hours = e.getHours()
                      const minutes = e.getMinutes()
                      
                      // Create moment in user's timezone with the selected date/time values
                      const selectedMoment = moment.tz([year, month, day, hours, minutes], userTimezone)
                      const currentMoment = moment.tz(userTimezone)
                      
                      if (selectedMoment.isAfter(currentMoment)) {
                        let err = {...error}
                        delete err.late
                        delete err.when
                        setBulkMessageData({...bulkMessageData, scheduledAt: e})
                        setError({...err})
                      } else {
                        setBulkMessageData({...bulkMessageData, scheduledAt: e})
                        setError({
                          ...error,
                          late: 'Please select proper time to schedule message',
                          when: 'please select when',
                        })
                      }
                    }}
                    selected={bulkMessageData?.scheduledAt ? bulkMessageData?.scheduledAt : ''}
                  />
                  {error?.late ? (
                    <span className='text-danger'>
                      {error?.late}, current time is{' '}
                      {moment.tz(userTimezoneNow, userTimezone).format('MMMM D, yyyy h:mm a')}
                    </span>
                  ) : (
                    <span className='text-muted text-sm mb-20'>
                      current time is{' '}
                      {moment.tz(userTimezoneNow, userTimezone).format('MMMM D, yyyy h:mm a')}
                    </span>
                  )}
                </div>
              )}
              {userValues?.smsStatus === 'approved' && !bulkMessageData?.abTest && (
                <>
                  {isDefaultRegion && (
                    <>
                      <div className='form-check form-check-custom form-check-sm form-check-solid'>
                        <input
                          className='form-check-input me-5'
                          id='option-late-1'
                          type='radio'
                          checked={
                            !bulkMessageData.isIntervalSend && !bulkMessageData.staggerMessages
                          }
                          onChange={() => {
                            setBulkMessageData({
                              ...bulkMessageData,
                              staggerMessages: false,
                              isIntervalSend: false,
                            })
                          }}
                          name='stagger-late'
                        />
                        <div>
                          <label htmlFor='option-late-1' style={{lineHeight: '0.65'}}>
                            Normal Send
                          </label>
                          <p>The message will be sent immediately or at the scheduled time.</p>
                        </div>
                      </div>

                      <div className='form-check form-check-custom form-check-sm form-check-solid'>
                        <input
                          className='form-check-input me-5'
                          id='option-late-2'
                          type='radio'
                          checked={bulkMessageData.isIntervalSend}
                          onChange={() => {
                            setBulkMessageData({
                              ...bulkMessageData,
                              staggerMessages: false,
                              isIntervalSend: !bulkMessageData.isIntervalSend,
                            })
                          }}
                          name='stagger-late'
                        />
                        <div>
                          <label htmlFor='option-late-2' style={{lineHeight: '0.65'}}>
                            Send message over time{' '}
                          </label>
                          <p>Set a period of time for system to send out all your messages</p>
                        </div>
                      </div>
                      {bulkMessageData.isIntervalSend && (
                        <div className='row mb-3 ms-5'>
                          <div className='col-md-5'>
                            <Select
                              name='selector'
                              onChange={(e: any) => {
                                setBulkMessageData({
                                  ...bulkMessageData,
                                  interval: e.value,
                                })
                              }}
                              placeholder='Select interval'
                              data-testid='ddSelectInterval'
                              className='form-select bg-light-primary border-0 m-3 mb-0'
                              options={[
                                {value: 30, label: '30 Minutes'},
                                {value: 60, label: '1 Hour'},
                                {value: 120, label: '2 Hour'},
                                {value: 180, label: '3 Hour'},
                                {value: 240, label: '4 Hour'},
                                {value: 300, label: '5 Hour'},
                                {value: 360, label: '6 Hour'},
                                {value: 720, label: '12 Hour'},
                                {value: 1440, label: '1 Day'},
                                {value: 2160, label: '2 Day'},
                              ]}
                            />
                          </div>
                        </div>
                      )}

                      <div className='form-check form-check-custom form-check-sm form-check-solid'>
                        <input
                          className='form-check-input me-5'
                          id='option-late-3'
                          type='radio'
                          checked={bulkMessageData.staggerMessages}
                          onChange={() => {
                            setBulkMessageData({
                              ...bulkMessageData,
                              staggerMessages: !bulkMessageData.staggerMessages,
                              isIntervalSend: false,
                            })
                          }}
                          name='stagger-late'
                        />
                        <div>
                          <label htmlFor='option-late-3' style={{lineHeight: '0.65'}}>
                            Stagger messages
                          </label>
                          <p>
                            Set your messages to leave in batches at set intervals - control
                            exposure!
                          </p>
                        </div>
                      </div>
                      {bulkMessageData.staggerMessages && (
                        <div className='row mb-3 ms-5'>
                          <div className='col-md-5'>
                            <Select
                              name='selector'
                              data-testid='ddSelectQuantity'
                              className='form-select bg-light-primary border-0 m-3 mb-0'
                              onChange={(e: any) => {
                                setBulkMessageData({
                                  ...bulkMessageData,
                                  quantity: e.value,
                                })
                              }}
                              placeholder='Select quantity'
                              options={[
                                {value: 10, label: 10},
                                {value: 20, label: 20},
                                {value: 50, label: 50},
                                {value: 100, label: 100},
                                {value: 150, label: 150},
                                {value: 500, label: 500},
                                {value: 1000, label: 1000},
                                {value: 10000, label: 10000},
                                {value: 25000, label: 25000},
                                {value: 50000, label: 50000},
                                {value: 100000, label: 100000},
                              ]}
                            />
                          </div>
                          <div className='col-md-5'>
                            <Select
                              name='selector'
                              onChange={(e: any) => {
                                setBulkMessageData({
                                  ...bulkMessageData,
                                  interval: e.value,
                                })
                              }}
                              placeholder='Select interval'
                              data-testid='ddSelectInterval'
                              className='form-select bg-light-primary border-0 m-3 mb-0'
                              options={[
                                {value: 5, label: '5 Minutes'},
                                {value: 10, label: '10 Minutes'},
                                {value: 20, label: '20 Minutes'},
                                {value: 60, label: '1 Hour'},
                                {value: 720, label: '12 Hour'},
                                {value: 1440, label: '24 Hour'},
                              ]}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        {isDefaultRegion && bulkMessageData.camp_type === 'sms' && !bulkMessageData?.abTest && (
          <div className='form-group mb-10 mb-6 mt-6'>
            <div
              className='col-12 form-check form-check-custom form-check-sm form-check-solid mb-5'
              style={{marginTop: '0px !important'}}
            >
              <input
                className='form-check-input me-5'
                id='contact'
                data-testid='cbForwardReplyEmail'
                type={'checkbox'}
                onChange={(e) => {
                  setIsForwardIncomingMessage(!isForwardIncomingMessage)
                }}
                checked={isForwardIncomingMessage}
              />
              <label
                htmlFor='contact'
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                }}
              >
                Forwards incoming SMS
              </label>
            </div>
            {isForwardIncomingMessage && (
              <input
                type='text'
                data-testid='inputFormardedReplyEmail'
                value={bulkMessageData?.forwardReplyTo || ''}
                className='form-control form-control-lg form-control-solid w-100 react-tagsinput-input'
                placeholder='targetemail1@mail.com, targetemail2@mail.com'
                onChange={(e) =>
                  setBulkMessageData({...bulkMessageData, forwardReplyTo: e.target.value})
                }
              />
            )}
          </div>
        )}
      </>
    )
  }

  const SecondWhen = () => {
    if (!bulkMessageData?.abTest) {
      return
    }

    return (
      <>
        <h5>Message B</h5>
        <ul className='nav nav-tabs' id='myTab' role='tablist'>
          <li className='nav-item mb-3 me-3' role='presentation'>
            <button
              className='btn btn-outline btn-outline-dashed btn-outline-default nav-link p-4 w-100 px-6'
              id='Now-tab'
              data-bs-toggle='tab'
              data-bs-target='#Now'
              type='button'
              role='tab'
              data-testid='btnSendNowB'
              aria-controls='Now'
              aria-selected='false'
              onClick={() => {
                let errorData = {...error}

                delete errorData.whenSecond
                setError(errorData)
                setBulkMessageData({
                  ...bulkMessageData,
                  whenSecond: 'now',
                  scheduledAtSecond: new Date(),
                })
              }}
            >
              Now
            </button>
          </li>

          <li className='nav-item mb-3 me-3' role='presentation'>
            <button
              className='btn btn-outline btn-outline-dashed btn-outline-default nav-link p-4 w-100 px-6'
              id='Later-tab-second'
              data-bs-toggle='tab'
              data-bs-target='#Later-second'
              type='button'
              data-testid='btnSendLaterB'
              role='tab'
              aria-controls='Later-second'
              aria-selected='false'
              onClick={() => {
                setBulkMessageData({...bulkMessageData, whenSecond: 'later'})
              }}
            >
              Later
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          <div
            className='fade tab-pane'
            id='Later-second'
            role='tabpanel'
            aria-labelledby='Later-tab-second'
          >
            <div className='when'>
              {bulkMessageData?.whenSecond == 'later' && (
                <div className='col-sm-6 mb-5 select-date'>
                  <label htmlFor='' className='mb-2' data-testid='lblSelectDateB'>
                    Select Date & Time{' '}
                    <span className="">{timezoneLabel}</span>
                  </label>
                  <DatePicker
                    minDate={userTimezoneNow}
                    dateFormat='MMMM d, yyyy h:mm aa'
                    placeholderText='Select a date'
                    showTimeSelect
                    className='col-md-6 form-control form-control-lg form-control-solid border-0'
                    onChange={(e: any) => {
                      const year = e.getFullYear()
                      const month = e.getMonth()
                      const day = e.getDate()
                      const hours = e.getHours()
                      const minutes = e.getMinutes()
                      
                      // Create moment in user's timezone with the selected date/time values
                      const selectedMoment = moment.tz([year, month, day, hours, minutes], userTimezone)
                      const currentMoment = moment.tz(userTimezone)
                      
                      if (selectedMoment.isAfter(currentMoment)) {
                        let err = {...error}
                        delete err.lateSecond
                        delete err.whenSecond
                        setBulkMessageData({...bulkMessageData, scheduledAtSecond: e})
                        setError({...err})
                      } else {
                        setBulkMessageData({...bulkMessageData, scheduledAtSecond: e})
                        setError({
                          ...error,
                          lateSecond: 'Please select proper time to schedule message',
                          whenSecond: 'please select when',
                        })
                      }
                    }}
                    selected={
                      bulkMessageData?.scheduledAtSecond ? bulkMessageData?.scheduledAtSecond : ''
                    }
                  />
                  {error?.lateSecond ? (
                    <span className='text-danger'>
                      {error?.lateSecond}, current time is{' '}
                      {moment.tz(userTimezoneNow, userTimezone).format('MMMM D, yyyy h:mm a')}
                    </span>
                  ) : (
                    <span className='text-muted text-sm mb-20'>
                      current time is{' '}
                      {moment.tz(userTimezoneNow, userTimezone).format('MMMM D, yyyy h:mm a')}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
  return (
    <>
      <h2 className={`accordion-header ${bulkMessageData.when && 'successData'}`} id='headingfive'>
        <button
          className='collapsed accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapsefive'
          aria-expanded='false'
          aria-controls='collapsefive'
          onClick={() => {
            setCheckStep({
              gettingStarted: false,
              to: false,
              from: false,
              message: false,
              when: !checkStep.when,
            })
          }}
        >
          <div className='d-flex flex-column align-items-start gap-1'>
            <span className={checkStep.when ? 'text-primary' : ''}>When</span>
            <span className='accordion-subtitle fs-6 fw-normal lh-base'>{getSubtitle()}</span>
          </div>
        </button>
        <div className='bulk-message-collapse'>
          {bulkMessageData?.abTest ? (
            <div
              className='accordion-title-detail small'
              style={{color: `${!!bulkMessageData?.when ? '#1A1C37' : ''}`}}
            >
              <strong className='mb-2'>Message A: </strong>
            </div>
          ) : null}
          <div
            className='accordion-title-detail small'
            style={{color: `${!!bulkMessageData?.when ? '#1A1C37' : ''}`}}
          >
            {!!bulkMessageData?.when
              ? bulkMessageData?.when === 'later'
                ? 'Time: ' +
                  moment
                    .tz(bulkMessageData?.scheduledAt, moment.tz.guess())
                    .format('D MMMM YYYY. hh:mm a')
                : 'Time: Now'
              : 'Time You Choose'}
          </div>

          {bulkMessageData?.abTest ? (
            <>
              <div
                className='accordion-title-detail small'
                style={{color: `${!!bulkMessageData?.whenSecond ? '#1A1C37' : ''}`}}
              >
                <strong className='mb-2'>Message B: </strong>
              </div>
              <div
                className='accordion-title-detail small'
                style={{color: `${!!bulkMessageData?.whenSecond ? '#1A1C37' : ''}`}}
              >
                {!!bulkMessageData?.whenSecond
                  ? bulkMessageData?.whenSecond === 'later'
                    ? 'Time: ' +
                      moment
                        .tz(bulkMessageData?.scheduledAtSecond, moment.tz.guess())
                        .format('D MMMM YYYY. hh:mm a')
                    : 'Time: Now'
                  : 'Time You Choose'}
              </div>
            </>
          ) : null}
        </div>
      </h2>
      <div
        id='collapsefive'
        className={`accordion-collapse collapse ${checkStep.when && 'show'}`}
        aria-labelledby='headingfive'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <>
            {SingleWhen()}

            {SecondWhen()}
          </>
        </div>
      </div>
    </>
  )
}

export default Bulk_Message_when_v2
